import React from "react";
import { Controller } from "react-hook-form";

import Select, { components } from "react-select";
import { ErrorText } from "../styles";

function CheckboxOption(props) {
  return (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: 8 }}
        />
        <span>{props.label}</span>
      </div>
    </components.Option>
  );
}

function CustomSelectWithCheckbox({
  placeholder = "",
  rules = {},
  options = [],
  name = "",
  handleChange = null,
  isDisabled = false,
  defaultValue = [],
  maxWidth = null,
}) {
  return (
    <Controller
      name={name}
      rules={{ ...rules }}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => {
        const selected = field.value || [];
        const isError = fieldState?.error && !selected?.length;

        return (
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Select
              {...field}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              controlShouldRenderValue={false}
              options={options}
              isDisabled={isDisabled}
              menuPosition="absolute"
              menuPlacement="auto"
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: isError ? "#e6000f" : "#e5e7eb",
                  boxShadow: "none",
                  padding: "4px 0px",
                  "&:hover": {
                    borderColor: isError ? "#e6000f" : "#e5e7eb",
                  },
                  backgroundColor: "white",
                  boxShadow: "none",
                  outline: "none",
                  cursor: "pointer",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? " #e5e7eb"
                    : state.isFocused
                    ? "#f5f5f5"
                    : "transparent",
                  color: "#1f2937",
                  cursor: "pointer",
                  fontSize: 14,
                  lineHeight: "18px",
                  "&:hover": {
                    backgroundColor: "#e5e7eb",
                  },
                }),

                valueContainer: (base) => ({
                  ...base,
                  maxWidth,
                  fontSize: 14,
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: 14,
                }),
                input: (base) => ({
                  ...base,
                  fontSize: 14,
                }),
              }}
              components={{
                Option: CheckboxOption,
                IndicatorSeparator: () => null,
                MultiValue: () => null,
              }}
              className="basic-single"
              classNamePrefix="select"
              placeholder={placeholder}
              onChange={(option, actionMeta) => {
                if (
                  actionMeta.action === "remove-value" &&
                  actionMeta.removedValue.value === defaultValue?.[0]?.value
                ) {
                  return;
                }
                if (
                  actionMeta.action === "clear" &&
                  defaultValue.length === 1
                ) {
                  const defaultOption = options.find(
                    (opt) => opt.value === defaultValue?.[0]?.value
                  );

                  if (defaultOption) {
                    field.onChange([defaultOption]);
                    return;
                  } else {
                    field.onChange(option);
                  }
                }
                field.onChange(option);
                if (typeof handleChange === "function") {
                  handleChange(option);
                }
              }}
            />

            {selected?.length ? (
              <div
                style={{
                  marginTop: 8,
                  display: "flex",
                  gap: "8px",
                  flexWrap: "wrap",
                  maxWidth: "100%",
                }}
              >
                {selected.map((item) => (
                  <div
                    key={item.value}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "6px 10px",
                      background: "#f3f4f6",
                      borderRadius: 6,
                      marginBottom: 6,
                      gap: "8px",
                      width: "fit-content",
                      maxWidth: "100%",
                      minWidth: 0,
                      alignItems: "flex-start",
                    }}
                  >
                    <span
                      style={{
                        minWidth: 0,
                        maxWidth: "100%",
                        overflowWrap: "normal",
                        wordBreak: "normal",
                        fontSize: 14,
                        lineHeight: "18px",
                      }}
                    >
                      {item.label}
                    </span>

                    {item?.value !== defaultValue?.[0]?.value ? (
                      <button
                        type="button"
                        onClick={() => {
                          const newValue = selected.filter(
                            (opt) => opt.value !== item.value
                          );
                          field.onChange(newValue);

                          if (typeof handleChange === "function") {
                            handleChange(newValue, item);
                          }
                        }}
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          color: "#111827",
                          fontSize: "11px",
                          fontWeight: "bold",
                          flexShrink: 0,
                          lineHeight: "18px",
                          padding: 0,
                        }}
                      >
                        ✕
                      </button>
                    ) : null}
                  </div>
                ))}
              </div>
            ) : null}

            <ErrorText error={isError}>
              {isError ? fieldState.error?.message : "error placeholder"}
            </ErrorText>
          </div>
        );
      }}
    />
  );
}

export default React.memo(CustomSelectWithCheckbox);
